function AddClass(obj: HTMLElement, cName: string) {
  return obj && obj.classList.add(cName);
}

// ***Removes a particular class from an object, preserving other existing classes.
function KillClass(obj: HTMLElement, cName: string) {
  return obj && obj.classList.remove(cName);
}

// ***Returns true if the object has the class assigned, false otherwise.
function HasClass(obj: HTMLElement, cName: string) {
  return obj && obj.classList.contains(cName);
}

// *** This library is copyright 2004 by Gavin Kistner, !@phrogz.net
// *** It is covered under the license viewable at http://phrogz.net/JS/_ReuseLicense.txt
// *** Reuse or modification is free provided you abide by the terms of that license.
// *** (Including the first two lines above in your source code mostly satisfies the conditions.)

// tslint:disable-next-line
interface HTMLAnchorElement {
  tabID: string;
  tabContent: HTMLElement;
  semanticTab: HTMLAnchorElement;
  tabTOC: HTMLUListElement;
  prevTab: HTMLAnchorElement;
  nextTab: HTMLAnchorElement;
  previousTab: HTMLAnchorElement;
}

// tslint:disable-next-line
interface HTMLUListElement {
  activeTab: HTMLAnchorElement;
}

// *** Tabtastic -- see http://phrogz.net/JS/Tabstatic/index.html

window.addEventListener(
  "load",
  () => {
    const tocTag = "ul";
    const tocClass = "tabset_tabs";
    const tabTag = "a";
    // let contentClass = "tabset_content";

    function FindEl(tagName: string, evt: Event) {
      // Handle IE8 and lower which don't provide an Event
      // in callbacks. Can probably remove this at some point.
      if (!evt && window.event) {
        evt = window.event;
      }
      let el: Element = (evt.currentTarget || evt.srcElement) as Element;
      while (el && (!el.tagName || el.tagName.toLowerCase() !== tagName)) {
        el = el.parentNode as Element;
      }
      return el;
    }

    function SetTabActive(tab: HTMLAnchorElement) {
      if (tab.tabTOC.activeTab) {
        if (tab.tabTOC.activeTab === tab) {
          return;
        }
        KillClass(tab.tabTOC.activeTab, "active");
        if (tab.tabTOC.activeTab.tabContent) {
          KillClass(tab.tabTOC.activeTab.tabContent, "tabset_content_active");
        }
        // if (tab.tabTOC.activeTab.tabContent) tab.tabTOC.activeTab.tabContent.style.display='';
        if (tab.tabTOC.activeTab.prevTab) {
          KillClass(tab.tabTOC.activeTab.previousTab, "preActive");
        }
        if (tab.tabTOC.activeTab.nextTab) {
          KillClass(tab.tabTOC.activeTab.nextTab, "postActive");
        }
      }
      AddClass((tab.tabTOC.activeTab = tab), "active");
      if (tab.tabContent) {
        AddClass(tab.tabContent, "tabset_content_active");
      }
      // if (tab.tabContent) tab.tabContent.style.display='block';
      if (tab.prevTab) {
        AddClass(tab.prevTab, "preActive");
      }
      if (tab.nextTab) {
        AddClass(tab.nextTab, "postActive");
      }
    }

    function SetTabFromAnchor(evt: Event) {
      const scrollPosition = document.documentElement.scrollTop;
      const tab = (FindEl("a", evt) as HTMLAnchorElement).semanticTab;
      SetTabActive(tab);
      // Prevent default to prevent the browser from scrolling to the anchor
      evt.preventDefault();
      document.documentElement.scrollTop = scrollPosition;
      // http://lea.verou.me/2011/05/change-url-hash-without-page-jump/
      const hash = "#" + tab.tabID;
      if (history.pushState) {
        history.pushState(null, "", hash);
      } else {
        location.hash = hash;
      }
    }

    function Init() {
      const everyTabThereIsById: { [s: string]: HTMLAnchorElement } = {};

      const anchorMatch = /#([a-z][\w.:-]*)$/i;
      let match;
      const activeTabs = [];

      const tocs = document.getElementsByTagName(tocTag);
      for (let i = 0, len = tocs.length; i < len; i++) {
        const toc = tocs[i];
        if (!HasClass(toc, tocClass)) {
          continue;
        }

        let lastTab;
        const tabs = toc.getElementsByTagName(tabTag);
        for (let j = 0, len2 = tabs.length; j < len2; j++) {
          const tab = tabs[j];
          // tslint:disable-next-line:no-conditional-assignment
          if (!tab.href || !(match = anchorMatch.exec(tab.href))) {
            continue;
          }
          if (lastTab) {
            tab.prevTab = lastTab;
            lastTab.nextTab = tab;
          }
          tab.tabTOC = toc;
          everyTabThereIsById[(tab.tabID = match[1])] = tab;
          const tabElement = document.getElementById(tab.tabID);
          if (tabElement) {
            tab.tabContent = tabElement;
          }

          if (HasClass(tab, "active")) {
            activeTabs[activeTabs.length] = tab;
          }

          lastTab = tab;
        }
        AddClass(toc.getElementsByTagName("li")[0], "firstchild");
      }

      for (let i = 0, len = activeTabs.length; i < len; i++) {
        SetTabActive(activeTabs[i]);
      }

      let a = null;

      for (let i = 0, len = document.links.length; i < len; i++) {
        a = document.links[i] as HTMLAnchorElement;
        // tslint:disable-next-line:no-conditional-assignment
        if (!(match = anchorMatch.exec(a.href))) {
          continue;
        }
        // tslint:disable-next-line:no-conditional-assignment
        if ((a.semanticTab = everyTabThereIsById[match[1]])) {
          a.addEventListener("click", SetTabFromAnchor, false);
        }
      }

      if (
        // tslint:disable-next-line:no-conditional-assignment
        (match = anchorMatch.exec(location.href)) &&
        // tslint:disable-next-line:no-conditional-assignment
        (a = everyTabThereIsById[match[1]])
      ) {
        SetTabActive(a);
      }
    }

    Init();
  },
  false,
);
